import gql from "graphql-tag";

export const reorderBonusProgramTextsMutation = gql`
  mutation reorderBonusProgramTexts($order: [ID!]) {
    reorderBonusProgramTexts(order: $order) {
      id
    }
  }
`;
